import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import Grid from '@material-ui/core/Grid';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import { Framework } from '@flint/framework';

const handleEditSubscription = (id) => {
  Framework.redirect(`/edit-subscription/${id}`);
}

const useRowStyles = makeStyles(theme=>({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableRow: {
      fontSize: "17px",
      fontFamily: "Nunito Sans",
      fontStyle: "normal",
      lineHeight: "30px",
      color: "#000000",
  },
  colOrange:{
      color:"#DD7153",
  },
  collapsedSectionOpen:{
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(12.5),
  },
  collapsedSectionClose:{
    padding:0,
  },
  curPointer:{
    cursor:"pointer",
  }
}));

const Row=(props)=>{
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
  
    return (
      <React.Fragment>
        <TableRow className={classes.root} hover>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row" className={classes.tableRow}>
            {row.sku}
          </TableCell>
          <TableCell align="center" className={classes.tableRow}>{row.name}</TableCell>
          <TableCell align="center" className={classes.tableRow}>{`${row.price} ${row.currency}`}</TableCell>
          <TableCell align="center" className={classes.tableRow}>{row.tenure}</TableCell>
          <TableCell align="center" className={classes.tableRow}>{row.productCode}</TableCell>
          <TableCell align="center" className={`${classes.tableRow} ${row.active?classes.colOrange:null}`}>{row.active?"Active":"Inactive"}</TableCell>
          <TableCell align="center" className={`${classes.tableRow} ${classes.curPointer}`}>
            <IconButton aria-label="edit" onClick={() => handleEditSubscription(row.sku)}>
              <EditIcon />
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={open?classes.collapsedSectionOpen:classes.collapsedSectionClose} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">Description</Typography>
                  <Typography variant="subtitle1">
                    {row.description}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="h6">ISBN(s)</Typography>
                  <Typography variant="subtitle1">
                  {row.isbns.join(", ")}
                  </Typography>
                </Grid>
              </Grid>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  export default Row;